import styled from "styled-components";

export const ModalContentContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
  max-width: 400px;
  //   padding: 1rem;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  //   @media (max-width: 768px) {
  //     width: 100%;
  //     height: 100%;
  //   }
`;
export const ModalContentIconContainer = styled.div``;
export const ModalContentIcon = styled.img`
  object-fit: cover;
  width: 40px;
  height: 40px;
`;

export const ModalContentTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ModalContentTitle = styled.div`
  font-size: ${(props) => props.theme.fontLarge}px;
`;
export const ModalContentDescription = styled.div``;
export const ModalContentButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;
